<!-- Bank-transaction mode lives in the reconcile panel (app-transaction-detail-panel), whose
     body is the full height on offer: fill it. It was the window less 85px, for a header the
     panel no longer has, which left a blank strip under the scroll area. -->
<div id="activitydiv" #activityRoot class="activity-container" style="position: relative" (scroll)="onScroll($event)"
  [ngStyle]="{ 'height': isBankTransMode ? '100%' : (isInvoiceMode ? invoicePanelHeight : 'calc(100vh - 185px)'), 'padding-bottom': isInvoiceMode ? '0' : '' }">
  <div class="custom-mat-spinner" *ngIf="isSpinnerShown">
    <mat-spinner></mat-spinner>
    <div class="text">Data loading...</div>
  </div>

  <!-- Invoice mode: the segmented Activity timeline + Notes conversation shared
       with the contact panel replaces the legacy stacked Activity/Notes blocks
       below. Bank-transaction and supplier modes keep the original layout. -->
  <app-contact-activity
    *ngIf="isInvoiceMode && !isBankTransMode && !isSpinnerShown"
    [activities]="activities"
    [recordId]="recordId"
    [noteType]="noteType"
    [defaultView]="openNotesFirst ? 'notes' : 'activity'"
    [panelHeight]="invoicePanelHeight">
  </app-contact-activity>

  <section class="accordianpanel" *ngIf="!isInvoiceMode" [class]="isBankTransMode ? 'banktransPanel' : ''"
    [ngStyle]="{ 'border-top': isBankTransMode ? 'none' : '' }">
    <div class="block-title" style="margin-bottom: 15px" *ngIf="!isBankTransMode">
      <span (click)="isActivityExpanded = !isActivityExpanded">Activity</span>
      <span class="shevron" (click)="isActivityExpanded = !isActivityExpanded">
        <img [ngClass]="isActivityExpanded ? 'img-up' : ''" src="../../../../assets/img/invoiceForm/shevron.svg"
          alt="" />
      </span>
    </div>
    <div class="block-content" *ngIf="isActivityExpanded" [ngClass]="isActivityExpanded ? 'expaned' : ''">
      <div class="content" *ngIf="!isSpinnerShown">
        <div class="history" *ngIf="isInvoiceMode && activities?.length > 0">
          <div class="activity-card" *ngFor="let activity of activities">
            <div class="label" [ngClass]="{
                sup_img_box_Upload:
                  activity.stage == 'Submitted' ||
                  activity.stage == 'Document Submitted' ||
                  activity.stage == 'Sent for Approval',
                sup_img_box_Approved: activity.stage == 'Approved',
                sup_img_box_Published: activity.stage == 'Published',
                sup_img_box_Paid: activity.stage == 'Paid'
              }">
              <!-- <span>
                {{activity.actor ? activity.actor[0].toUpperCase() : 'U'}}
              </span> -->
            </div>
            <div class="desc">
              <div class="stage" [ngClass]="
                  !activity.actor && !activity.date ? 'no-margin-bottom' : ''
                ">
                {{ activity.stage
                }}<span *ngIf="activity.stage.toLowerCase() == 'submitted'">{{
                  activity.model
                  }}</span>
              </div>
              <div class="actor-date" *ngIf="activity.date">
                <span class="date-span" *ngIf="activity.date">{{
                  getFormattedDate(activity.date)
                  }}</span>
              </div>
              <div class="detail bg-gray" *ngIf="
                  activity.submissionMethod !== 'By Email' &&
                  activity.submissionMethod !== 'By Gmail Extension' &&
                  activity.submissionMethod !== 'By Inbox Assistant' &&
                  activity.submissionMethod !== 'By Outlook Addin'
                ">
                <div class="" *ngIf="
                    activity.submissionMethod && activity.stage != 'Published'
                  ">
                  {{ activity.submissionMethod }}
                </div>
                <div class="" *ngIf="activity.actor">
                  <span *ngIf="activity.actor">By {{ activity.actor }}&nbsp;</span>
                  <span *ngIf="activity.isAutoPublished">
                    <img class="lightning" src="../../../../../assets/img/invoiceForm/lightning.svg" alt="" />
                  </span>
                </div>
                <div class="note">{{ activity.note }}</div>
              </div>
              <div class="detail bg-gray" *ngIf="
                  activity.submissionMethod === 'By Email' ||
                  activity.submissionMethod === 'By Gmail Extension' ||
                  activity.submissionMethod === 'By Inbox Assistant' ||
                  activity.submissionMethod === 'By Outlook Addin'
                ">
                <div class="" *ngIf="
                    activity.submissionMethod && activity.stage != 'Published'
                  ">
                  {{ activity.submissionMethod }}
                  <ng-container *ngIf="
                      activity.submissionMethod === 'By Inbox Assistant' &&
                      activity.details != null
                    ">
                    <i class="fa fa-info-circle tooltip-title" aria-hidden="true">
                      <span class="tooltiptext">{{ activity.details }}</span></i></ng-container>
                </div>

                <div class="" *ngIf="activity.actor">
                  <span *ngIf="activity.actor">{{ activity.actor }}&nbsp;</span>
                  <span *ngIf="activity.isAutoPublished">
                    <img class="lightning" src="../../../../../assets/img/invoiceForm/lightning.svg" alt="" />
                  </span>
                </div>
                <div class="" *ngIf="activity.from">
                  <br />
                  <div *ngIf="activity.from">
                    From: {{ activity.from }}&nbsp;
                  </div>
                  <div *ngIf="activity.subject">
                    Subject: {{ activity.subject }}&nbsp;
                  </div>

                  <div class="container body-container" [class.show]="activity.visible" *ngIf="activity.body"
                    [innerHtml]="activity.body">
                    &nbsp;
                    <br />
                    <br />
                  </div>
                  <a *ngIf="activity.body" class="showmore" (click)="activity.visible = !activity.visible">{{
                    activity.visible ? "Show less" : "Show More" }}
                  </a>
                </div>
                <div class="" *ngIf="!activity.from && activity.stage != 'Published'">
                  <div class="history no-activity-detail">
                    No details to display
                  </div>
                </div>
              </div>
            </div>
            <div class="line" *ngIf="activities.length > 1"></div>
          </div>
        </div>
        <div class="btp" *ngIf="isBankTransMode && activities?.length > 0">
          <!-- One header row: the tabs, then paging across the transactions the host selected
               (only when there is more than one), with room on the right for the panel's
               floating close button rather than a band of its own above them. -->
          <div class="btp__head">
            <section class="tab-header tab-header--panel">
              <div class="tab" [ngClass]="currentPannel == panels.DetailsTab ? 'active' : ''"
                (click)="tabClick(panels.DetailsTab, false)">
                <div class="caption">Details</div>
                <div class="underline"></div>
              </div>
              <div class="tab" [ngClass]="currentPannel == panels.ActivityTab ? 'active' : ''"
                (click)="tabClick(panels.ActivityTab, false)">
                <div class="caption">Activity</div>
                <div class="underline"></div>
              </div>
            </section>

            <div class="btp__nav" *ngIf="activities.length > 1">
              <button type="button" class="btp__arrow" aria-label="Previous transaction"
                [disabled]="curIdx === 0" (click)="changeTransaction('prev')">
                <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
                  <path d="M10 3L5 8l5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </button>
              <span class="btp__count">{{ curIdx + 1 }} of {{ activities.length }}</span>
              <button type="button" class="btp__arrow" aria-label="Next transaction"
                [disabled]="curIdx === activities.length - 1" (click)="changeTransaction('next')">
                <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
                  <path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </button>
            </div>
          </div>

          <app-bank-transaction-detail [activities]="activities" [curIdx]="curIdx" (assingTrans)="assignTrans($event)"
            *ngIf="currentPannel == panels.DetailsTab"></app-bank-transaction-detail>
        </div>
        <div class="history" *ngIf="!isInvoiceMode && !isBankTransMode && activities?.length > 0">
          <div class="activity-card" *ngFor="let activity of activities">
            <div class="supplier-label">
              <span></span>
            </div>
            <div class="desc">
              <div class="stage" [ngClass]="
                  !activity.actor && !activity.date ? 'no-margin-bottom' : ''
                ">
                {{ activity.stage }}
              </div>
              <div class="actor-date" *ngIf="activity.date">
                <span class="date-span" *ngIf="activity.date">{{ activity.date | formatedDate }} at
                  {{ activity.date | date : "h:mm a" }}</span>
              </div>
              <div class="detail bg-gray" *ngIf="activity.actor">
                <div class="" *ngIf="activity.submissionMethod">
                  {{ activity.submissionMethod }}
                </div>
                <div class="" *ngIf="activity.actor">
                  <span *ngIf="activity.actor">By {{ activity.actor }}&nbsp;</span>
                  <span *ngIf="activity.isAutoPublished">
                    <img class="lightning" src="../../../../../assets/img/invoiceForm/lightning.svg" alt="" />
                  </span>
                </div>
              </div>
            </div>
            <div class="line supplier-line" *ngIf="activities.length > 1"></div>
          </div>
        </div>
        <div class="history no-activity" *ngIf="!activities || activities?.length == 0">
          No activity data
        </div>
      </div>
    </div>
  </section>

  <section class="accordianpanel accordianRelated"
    *ngIf="isBankTransMode && currentPannel == panels.DetailsTab && !isSpinnerShown">
    <div class="section-label" *ngIf="invoiceLines.length > 0">Matched to</div>
    <div class="block-content">
      <div *ngIf="!isManualPaperwork">
        <!-- Reconciled outside Synced: there is nothing here to match or code, and offering to
             would code it a second time. Point to where its coding lives instead. -->
        <div class="rp-elsewhere" *ngIf="reconciledElsewhere">
          <div class="rp-elsewhere__title">
            <i class="fa fa-check-circle" aria-hidden="true"></i>
            Reconciled outside Synced
          </div>
          <div class="rp-elsewhere__note">
            This transaction was reconciled in {{ accountingSystemName || 'your accounting system' }}, so Synced
            doesn't have its coding. See {{ accountingSystemName || 'your accounting system' }} for the details.
          </div>
        </div>

        <!-- Unmatched: what the matcher found, then coding it yourself -- the same form as the
             row's "Add coding" dialog, so the two never drift apart. -->
        <div class="rp-unmatched" *ngIf="invoiceLines.length == 0 && !reconciledElsewhere">
          <div class="section-label">
            Suggested matches
            <span class="section-label__count" *ngIf="visibleSuggestionCount > 0">{{ visibleSuggestionCount }}</span>
          </div>

          <div class="rp-empty" *ngIf="visibleSuggestionCount == 0">
            No bills or receipts match this transaction yet.
          </div>

          <ng-template #findOtherMatches>
            <button type="button" class="rp-find-matches" *ngIf="canFindOtherMatches" (click)="openFindMatches()">
              <i class="fa fa-search" aria-hidden="true"></i>
              Find other matches
            </button>
          </ng-template>
          <ng-container *ngIf="visibleSuggestionCount == 0">
            <ng-container *ngTemplateOutlet="findOtherMatches"></ng-container>
          </ng-container>

          <div class="suggest-list" *ngIf="visibleSuggestionCount > 0">
            <ng-container *ngFor="let item of unreconciledData">
              <div class="suggest-card" *ngIf="item.visible" [class.suggest-card--selected]="item.selected"
                [title]="item.selected ? 'Click to deselect' : 'Select this match'"
                (click)="changeSelectedMatch(item.selected, item.id)">
                <div class="suggest-card__row">
                  <app-supplier-avatar class="rp-avatar" [ngClass]="item?.hexColorClass"
                    [supplierId]="item?.supplierId" [supplierName]="item?.supplierName"><span>{{ item?.shortCode }}</span></app-supplier-avatar>
                  <div class="suggest-card__details">
                    <div class="suggest-card__name">
                      <span *ngIf="item.supplierName" [appOpenSupplier]="item.supplierId">{{ item.supplierName }}</span>
                      <span class="suggest-card__no-supplier" *ngIf="!item.supplierName">No supplier</span>
                    </div>
                    <div class="suggest-card__meta">
                      {{ item.date | formatedDate }}<span *ngIf="item.accountName"> · {{ item.accountName }}</span>
                    </div>
                    <div class="suggest-card__submitter" *ngIf="item.submitterName"
                      [title]="'Submitted by ' + item.submitterName">
                      Submitted by {{ item.submitterName }}
                    </div>
                  </div>
                  <div class="suggest-card__amount">
                    <span *ngIf="item.type == 'ACCPAYCREDIT'">+{{ (item.amountDue < 0 ? item.amountDue * -1 :
                        item.amountDue) | number : '1.2-2' }}</span>
                    <span *ngIf="item.type != 'ACCPAYCREDIT'">-{{ (item.amountDue < 0 ? item.amountDue * -1 :
                        item.amountDue) | number : '1.2-2' }}</span>
                  </div>
                  <button type="button" class="suggest-card__dismiss" *ngIf="!item.selected"
                    (click)="$event.stopPropagation(); removeSuggestion(item.id)"
                    title="Not this one" aria-label="Dismiss this suggestion">&times;</button>
                </div>
                <!-- The sum the match rests on: the bank's amount against the document's, and
                     what is left over. Matched on size, as the matcher does. -->
                <div class="match-calc" *ngIf="item.selected" (click)="$event.stopPropagation()">
                  <div class="match-calc__row">
                    <span>Bank transaction</span>
                    <span>{{ panelTransactionAmount | number : '1.2-2' }}</span>
                  </div>
                  <div class="match-calc__row">
                    <span>{{ item.supplierName || 'This match' }}</span>
                    <span>{{ matchAmount(item) | number : '1.2-2' }}</span>
                  </div>
                  <div class="match-calc__row match-calc__row--total"
                    [class.match-calc__row--off]="matchDifference(item) !== 0">
                    <span>
                      <i class="fa" [ngClass]="matchDifference(item) === 0 ? 'fa-check-circle' : 'fa-exclamation-circle'"
                        aria-hidden="true"></i>
                      {{ matchDifference(item) === 0 ? 'Amounts agree' : 'Difference' }}
                    </span>
                    <span>{{ matchDifference(item) | number : '1.2-2' }}</span>
                  </div>
                </div>
                <div class="suggest-card__confirm" *ngIf="item.selected">
                  <button type="button" class="sd-btn sd-btn--primary suggest-card__confirm-btn"
                    (click)="$event.stopPropagation(); reconcileData.required_Fields ? matchTransaction() : openTransaction()"
                    [disabled]="matchProcessing || codingDisabled" [class.spinner]="matchProcessing">
                    <span *ngIf="reconcileData.required_Fields">Confirm match</span>
                    <span *ngIf="!reconcileData.required_Fields">Add details &amp; match</span>
                  </button>
                  <button type="button" class="sd-btn sd-btn--secondary suggest-card__view-btn"
                    (click)="$event.stopPropagation(); showInvoiceSideBar(item.id, false)">
                    View
                  </button>
                </div>
                <button type="button" class="suggest-card__deselect" *ngIf="item.selected && !codingDisabled"
                  (click)="$event.stopPropagation(); changeSelectedMatch(true, item.id)">
                  Not this one — code it myself
                </button>
              </div>
            </ng-container>
          </div>

          <ng-container *ngIf="visibleSuggestionCount > 0">
            <ng-container *ngTemplateOutlet="findOtherMatches"></ng-container>
          </ng-container>

          <!-- A chosen match is the answer; coding by hand comes back if it is deselected. -->
          <ng-container *ngIf="!codingDisabled && panelCodingTransactions.length && !isMatchSelected">
            <div class="section-label rp-code-label">
              {{ visibleSuggestionCount > 0 ? 'Or code it yourself' : 'Code it yourself' }}
            </div>
            <!-- Re-created per transaction as the panel pages, so no field carries over. -->
            <app-manual-coding-modal *ngFor="let key of [panelCodingKey]" [inline]="true"
              [transactions]="panelCodingTransactions" [aiSuggestion]="panelCodingSuggestion" [busy]="panelCodingBusy"
              (submit)="onPanelCoding($event)">
            </app-manual-coding-modal>
          </ng-container>
        </div>
        <div class="matched-section" *ngIf="invoiceLines.length > 0">
          <ng-container *ngFor="let row of invoiceLines">
            <div class="matched-card">
              <div class="matched-card__head">
                <app-supplier-avatar class="rp-avatar" [ngClass]="row.hexColorClass"
                  [supplierId]="row.supplierId" [supplierName]="row.supplierName"><span>{{ initialsOf(row.supplierName) }}</span></app-supplier-avatar>
                <div class="matched-card__text">
                  <div class="matched-card__title">
                    <span *ngIf="row.supplierName" [appOpenSupplier]="row.supplierId">{{ row.supplierName }}</span>
                    <span *ngIf="!row.supplierName" class="matched-card__placeholder">No supplier</span>
                  </div>
                  <div class="matched-card__meta">
                    <span>{{ row.date | formatedDate }}</span>
                    <span *ngIf="row.accountName"> · {{ row.accountName }}</span>
                  </div>
                </div>
                <div class="matched-card__amount">
                  <span *ngIf="row.amountDue === 'Infinity'">{{ row.total | number : '1.2-2' }}</span>
                  <span *ngIf="row.amountDue > 0">{{ row.amountDue | number : '1.2-2' }}</span>
                  <span *ngIf="row.amountDue < 0">({{ row.amountDue * -1 | number : '1.2-2' }})</span>
                </div>
              </div>
              <div class="matched-card__actions">
                <button type="button" class="matched-card__view-btn"
                  (click)="showInvoiceSideBar(activities[curIdx]['relatedID'], false)">
                  View expense
                </button>
                <button type="button" class="matched-card__unmatch-btn"
                  (click)="confirmUnmatch(activities[curIdx]['relatedID'], row.supplierName)"
                  [disabled]="roleId === '3' && reportStatus === '1'"
                  [title]="roleId === '3' && reportStatus === '1' ? 'Cannot unmatch while report is sent for approval' : ''">
                  Unmatch
                </button>
              </div>
            </div>
          </ng-container>
        </div>
        <div class="buttons">
          <button id="saveButton" type="button" class="btn-save" style="position: relative" (click)="openTransaction()"
            *ngIf="isManualPaperwork && selectedSupplierName && !reconcileData.required_Fields"
            [disabled]="matchProcessing" [class.spinner]="matchProcessing">
            Add Details
          </button>
          <button id="saveButton" type="button" class="btn-save" style="position: relative" (click)="matchTransaction()"
            *ngIf="isManualPaperwork && selectedSupplierName && reconcileData.required_Fields"
            [disabled]="matchProcessing" [class.spinner]="matchProcessing">
            Match
          </button>
        </div>

      </div>
      <div class="reconcile-Manual" *ngIf="isManualSaved && selectedSupplierName">
        <div class="col-sm-12 reconcile-header reconciled-Add">
          Reconcile
          <button type="button" class="btn-close close" aria-label="Close" (click)="cancelUpload()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="col-sm-12">
          <div class="separator">Transactions</div>
        </div>
        <div class="col-sm-12">
          <div class="col-sm-9 match-label">
            {{ reconciledDataAdd.unRecDescription }}
          </div>
          <div class="col-sm-3 match-red-label" *ngIf="reconciledDataAdd.amountDue > 0">
            +{{ reconciledDataAdd.amountDue | number : "1.2-2" }}
          </div>
          <div class="col-sm-3 match-red-label" *ngIf="reconciledDataAdd.amountDue < 0">
            ({{ reconciledDataAdd.amountDue * -1 | number : "1.2-2" }})
          </div>
          <div class="col-sm-3 match-red-label" *ngIf="reconciledDataAdd.amountDue == 0">
            -
          </div>
        </div>
        <div class="col-sm-12">
          <div class="separator">Paperwork</div>
        </div>
        <div class="col-sm-12">
          <div class="col-sm-9 match-label">
            {{ reconciledDataAdd.supplierName }} -
            {{ reconciledDataAdd.invoiceNumber }}
          </div>
          <div class="col-sm-3 match-red-label">
            ({{
            (reconciledDataAdd.amountDue < 0 ? reconciledDataAdd.amountDue * -1 : reconciledDataAdd.amountDue ) | number
              : "1.2-2" }}) </div>
          </div>
          <div class="col-sm-12" style="padding-top: 10px;">
            <div class="match-label">
              {{ reconciledDataAdd.accountName }}
            </div>
          </div>
          <div class="match-footer">
            <div class="col-sm-12">
              <div class="col-sm-9 match-label">Difference</div>
              <div class="col-sm-3 match-red-label" style="margin-top: -10px !important; margin-right: 15px">
                <label class="switch">0.00</label>
              </div>
            </div>
          </div>
        </div>
        <div class="buttons">
          <button id="saveManualButton" type="button" class="btn-save" style="position: relative"
            (click)="uploadManualInvoice()" *ngIf="isManualSaved && selectedSupplierName && invoiceLines.length == 0"
            [disabled]="isSaving" [class.spinner]="isSaving">
            Match
          </button>
        </div>
      </div>
  </section>

  <section class="accordianpanel" style="height: 350px; background: #fff; width: calc(100vw);"
    [ngStyle]="{'width': isoutlookEnv || isChromeEnv ? '310px' : '100%'}" *ngIf="
      ((isBankTransMode && currentPannel == panels.ActivityTab) ||
      !isBankTransMode) && !isInvoiceMode
    ">
    <div class="block-title" style="margin-bottom: 15px" *ngIf="!isBankTransMode">
      <span (click)="isNoteExpanded = !isNoteExpanded">Notes</span>
      <span class="shevron" (click)="isNoteExpanded = !isNoteExpanded">
        <img [ngClass]="isNoteExpanded ? 'img-up' : ''" src="../../../../assets/img/invoiceForm/shevron.svg" alt="" />
      </span>
    </div>
    <div class="block-title" style="margin-bottom: 15px" *ngIf="isBankTransMode">
      <span (click)="isNoteExpanded = !isNoteExpanded">Comments</span>
    </div>
    <div class="block-content" *ngIf="isNoteExpanded" [ngClass]="isNoteExpanded ? 'expaned' : ''">
      <div class="content note-content" style="max-height: 400px; overflow-y: auto; overflow-x: hidden; width: 100%;"
        *ngIf="!isSpinnerShown && this.activities.length > 0">
        <app-notes [noteType]="noteType" [recordId]="recordId" [relatedID]="this.activities[this.curIdx]['relatedID']"
          [relatedName]="this.activities[this.curIdx]['relatedName']" (transNote)="transNote($event)"
          [isBankTransMode]="isBankTransMode" (uploadedFile)="uploadFile($event)"></app-notes>
      </div>
    </div>
  </section>
</div>

<div [ngClass]="showInvoiceFormPanel ? 'sidenav sidenav-show' : 'sidenav'">
  <div class="sidenav_in">
    <div>
      <app-upload-invoice-form *ngIf="showInvoiceFormPanel" [isEditable]="invoiceEditable" [billsToPayMode]="false"
        [hexColorClass]="hexColorClass" [heightDeduct]="130" (closeFormOnBillsToPayEvent)="closeInvoiceFormPanel()"
        (closeFormOnMatch)="closeSidebarOnMatchPublish()" [currentPannel]="currentPannel" [isInboxMobileMode]="true"
        [currentSelectedMatch]="reconcileData ? reconcileData.unreconciledReportId : null">
      </app-upload-invoice-form>
    </div>
  </div>
</div>

<!-- Find other matches: every document no transaction is matched to yet. The dialog kit
     (.sd-scrim / .sd-modal / .sd-form, shared/styles/_dialog.scss). -->
<div class="sd-scrim fm-scrim" *ngIf="findMatchOpen" (click)="closeFindMatches()">
  <div class="sd-modal fm-modal" role="dialog" aria-modal="true" aria-labelledby="fm-title"
    (click)="$event.stopPropagation()" (keydown.escape)="closeFindMatches()">
    <div class="sd-form fm-form">
      <div class="sd-form__head">
        <div class="sd-form__head-text">
          <h3 class="sd-form__title" id="fm-title">Find a match</h3>
          <p class="sd-form__subtitle">
            Bills and receipts not yet matched to a transaction, closest in amount to this
            one ({{ panelTransactionAmount | number : '1.2-2' }}) first.
          </p>
        </div>
        <button type="button" class="sd-icon-btn" aria-label="Close" (click)="closeFindMatches()">
          <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
          </svg>
        </button>
      </div>

      <div class="fm-search">
        <i class="fa fa-search" aria-hidden="true"></i>
        <input type="text" class="fm-search__input" placeholder="Search supplier, reference, amount or submitter"
          id="fm-search-input" aria-label="Search unmatched bills and receipts" autocomplete="off"
          [ngModel]="findMatchQuery" (ngModelChange)="onFindMatchQuery($event)" />
        <span class="fm-search__busy" *ngIf="findMatchLoading && findMatchRows.length">Searching…</span>
      </div>

      <div class="fm-list" role="listbox" aria-label="Unmatched bills and receipts">
        <!-- A table rather than cards: the headings say what each value is once, so a row is
             a supplier, a date, a person and an amount, each in the same place every time. -->
        <ng-template #fmSortCaret let-key>
          <svg class="fm-sort__caret" [class.fm-sort__caret--up]="matchSortState(key) === 'ascending'"
               viewBox="0 0 10 6" fill="none" aria-hidden="true">
            <path d="M1 1.5L5 5l4-3.5" stroke="currentColor" stroke-width="1.5"
                  stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </ng-template>

        <!-- Each heading sorts: ascending, descending, then back to closest-in-amount. -->
        <div class="fm-head" *ngIf="findMatchRows.length">
          <button type="button" class="fm-sort" [class.fm-sort--on]="findMatchSortKey === 'supplier'"
                  [attr.aria-sort]="matchSortState('supplier')" title="Sort by supplier"
                  (click)="sortMatchesBy('supplier')">
            Document <ng-container *ngTemplateOutlet="fmSortCaret; context: { $implicit: 'supplier' }"></ng-container>
          </button>
          <button type="button" class="fm-sort" [class.fm-sort--on]="findMatchSortKey === 'date'"
                  [attr.aria-sort]="matchSortState('date')" title="Sort by date"
                  (click)="sortMatchesBy('date')">
            Date <ng-container *ngTemplateOutlet="fmSortCaret; context: { $implicit: 'date' }"></ng-container>
          </button>
          <button type="button" class="fm-sort fm-col-submitter" [class.fm-sort--on]="findMatchSortKey === 'submitter'"
                  [attr.aria-sort]="matchSortState('submitter')" title="Sort by submitter"
                  (click)="sortMatchesBy('submitter')">
            Submitted by <ng-container *ngTemplateOutlet="fmSortCaret; context: { $implicit: 'submitter' }"></ng-container>
          </button>
          <button type="button" class="fm-sort fm-sort--end" [class.fm-sort--on]="findMatchSortKey === 'amount'"
                  [attr.aria-sort]="matchSortState('amount')" title="Sort by amount"
                  (click)="sortMatchesBy('amount')">
            Amount <ng-container *ngTemplateOutlet="fmSortCaret; context: { $implicit: 'amount' }"></ng-container>
          </button>
        </div>

        <button type="button" class="fm-row" role="option"
          *ngFor="let row of findMatchVisibleRows; trackBy: trackByMatchId" (click)="pickOtherMatch(row)">
          <span class="fm-row__doc">
            <span class="fm-row__name">
              <span *ngIf="row.supplierName">{{ row.supplierName }}</span>
              <span class="suggest-card__no-supplier" *ngIf="!row.supplierName">No supplier</span>
              <span class="fm-row__tag" *ngIf="isAlreadySuggested(row)">Suggested</span>
            </span>
            <span class="fm-row__sub" *ngIf="row.invoiceNumber || row.accountName">
              <span class="fm-row__ref" *ngIf="row.invoiceNumber">{{ row.invoiceNumber }}</span>
              <span *ngIf="row.accountName">{{ row.accountName }}</span>
            </span>
          </span>
          <span class="fm-row__date">{{ row.date | formatedDate }}</span>
          <span class="fm-row__submitter fm-col-submitter" [title]="row.submitterName || ''">
            {{ row.submitterName || '—' }}
          </span>
          <!-- The amount, and under it how far that is from the bank line: the thing being
               judged when a match is picked by hand. -->
          <span class="fm-row__figures fm-col-amount">
            <span class="fm-row__amount">{{ matchAmount(row) | number : '1.2-2' }}</span>
            <span class="fm-row__diff" [class.fm-row__diff--exact]="matchDifference(row) === 0">
              {{ matchDifferenceLabel(row) }}
            </span>
          </span>
        </button>

        <button type="button" class="fm-more" *ngIf="findMatchHiddenCount > 0" (click)="showMoreMatches()">
          Show {{ findMatchHiddenCount < findMatchPageSize ? findMatchHiddenCount : findMatchPageSize }} more
          <span class="fm-more__count">{{ findMatchHiddenCount }} not shown</span>
        </button>

        <div class="fm-note" *ngIf="findMatchLoading && !findMatchRows.length">Loading…</div>
        <div class="fm-note" *ngIf="!findMatchLoading && !findMatchError && !findMatchRows.length">
          {{ findMatchQuery ? 'Nothing unmatched fits "' + findMatchQuery + '".' : 'Every bill and receipt is already matched.' }}
        </div>
        <div class="fm-note fm-note--error" *ngIf="findMatchError" role="alert">
          {{ findMatchError }}
          <button type="button" class="fm-note__retry" (click)="retryFindMatches()">Retry</button>
        </div>
        <div class="fm-note" *ngIf="!findMatchLoading && findMatchHiddenCount === 0 && findMatchRows.length >= findMatchLimit">
          These are the closest {{ findMatchLimit }}. Search to find others.
        </div>
      </div>
    </div>
  </div>
</div>

<app-expense-modal *ngIf="showExpenseModal" [amount]="activities[curIdx].amount"
  [date]="activities[curIdx].transactionDate" [relatedId]="activities[curIdx].relatedID"
  [accountId]="activities[curIdx].accountID" [isPaperwork]="true" (onClose)="handleExpenseModalClose($event)">
</app-expense-modal>